import * as yup from 'yup'

const versionSchema = yup.object().shape({
  message: yup.string().required(),
  url: yup.string().url().required(),
  startsAt: yup.date().required(),
  endsAt: yup
    .date()
    .nullable()
    .min(yup.ref('startsAt'), 'Prazo não pode ser anterior à data de início'),
  observation: yup.string(),
})

export default versionSchema
